





















































































import { Component, Vue, Watch } from 'vue-property-decorator';
import { ValidationProvider, ValidationObserver } from 'vee-validate';
import FooterComponent from '@/components/footer.component.vue';
import AuthenticationModule from '@/store/modules/authentication.module';
import store from '@/store';
import { getModule } from 'vuex-module-decorators';
import { mapState, mapGetters } from 'vuex';
import { routePath } from '@/constants/route.constants';
import { Role } from '@/constants/role.constants';
// import { container, cid } from 'inversify-props';
// import { PaymentsService } from '../../services/payments.service';
// import RegisteredTagModule from '@/store/modules/registered-tag.module';
// import { UpdateRegisteredTagRequest } from '../../models/DTO/registered-tag/update-registered-tag-request.model';
// import CustomersModule from '@/store/modules/customer.module';
// import { PreferredContactMethodType } from '@/constants/preferred-contact-method-type';
// import { PhoneNumberType } from '@/constants/phone-number-type';
// import AdminUserModule from '@/store/modules/admin-user.module';
// import VeterinarianOfficeUserModule from '@/store/modules/veterinarian-office-user.module';

const authenticationModule: AuthenticationModule = getModule(
  AuthenticationModule,
  store
);

@Component({
  components: {
    ValidationObserver,
    ValidationProvider,
    FooterComponent
  },
  computed: {
    ...mapState('authentication', ['showButtonLoading']),
    ...mapGetters('authentication', ['hasErrorMessages', 'errorMessages'])
  }
})
export default class LoginFormComponent extends Vue {
  public showButtonLoading!: boolean;
  public hasErrorMessages!: boolean;
  public errorMessages!: Array<string>;
  public email = '';
  public password = '';

  public $refs: {
    form: HTMLFormElement;
  };

  public get roles(): Array<string> {
    return authenticationModule.jwtRoles;
  }

  @Watch('hasErrorMessages')
  private onHasErrorMessagesChanged(value: boolean) {
    if (value) {
      return this.$toasted.error(this.errorMessages.join());
    }
  }

  public created() {
    this.email = process.env.VUE_APP_EMAIL ?? '';
    this.password = process.env.VUE_APP_PASSWORD ?? '';
  }

  public async onLoginClick() {
    const success: boolean = await this.$refs.form.validate();

    if (!success) {
      return;
    }

    // setup login
    await authenticationModule.loginAction({
      email: this.email,
      password: this.password,
      isCustomer: false
    });

    if (!this.hasErrorMessages) {
      if (this.roles.includes(Role.Admin)) {
        await this.$router.replace({ path: routePath.admin.base });
      } else if (
        this.roles.includes(Role.Veterinarian) ||
        this.roles.includes(Role.VeterinarianUser)
      ) {
        await this.$router.replace({ path: routePath.veterinarian.base });
      }
    }
  }

  // public async onLoginClick() {
  //   const success: boolean = await this.$refs.form.validate();

  //   if (!success) {
  //     return;
  //   }

  //   // await authenticationModule.loginAction({
  //   //   email: this.email,
  //   //   password: this.password,
  //   //   isCustomer: false
  //   // });

  //   // await authenticationModule.customerLoginTokenRequestAction({
  //   //   email: this.email
  //   // });

  //   // await authenticationModule.loginAction({
  //   //   email: this.email,
  //   //   password: this.password,
  //   //   isCustomer: true
  //   // });

  //   // await authenticationModule.logoutAction();

  //   // const adminUserModule = getModule(AdminUserModule, store);
  //   // await adminUserModule.getAllAdminUsersAction();
  //   // setTimeout(() => {
  //   //   adminUserModule.resetStateAction();
  //   // }, 5000);

  //   // await authenticationModule.registerVeterinarianAction({
  //   //   email: 'scott+vetuser1@redhawk-tech.com',
  //   //   firstName: 'Scott',
  //   //   lastName: 'Vet User 1',
  //   //   veterinarianOfficeId: 'AFB50A9E-0D78-4247-820F-0045093545D0',
  //   //   role: 'Veterinarian_User'
  //   // });

  //   // const vetUserModule = getModule(VeterinarianOfficeUserModule, store);
  //   // // await vetUserModule.getByIdAction('6dd5b5c1-6d31-4cfa-adc7-f224ec0ec9b4');
  //   // await vetUserModule.updateVeterinarianOfficeUserAction({
  //   //   id: '5e8211ee-60fa-44c9-abfa-5141e1839838',
  //   //   firstName: 'Scott',
  //   //   lastName: 'Vet User 1',
  //   //   rolesToAdd: [Role.VeterinarianUser /* , Role.Customer */],
  //   //   rolesToRemove: [Role.Customer]
  //   // });

  //   // const customersModule = getModule(CustomersModule, store);
  //   // await customersModule.getAllCustomersAction();
  //   // await customersModule.getCustomerByIdAction(
  //   //   'e61654f6-e2b7-4b90-8ae7-00775cca16c7'
  //   // );
  //   // await customersModule.getCustomerByEmailAction(
  //   //   'scott+customer3@redhawk-tech.com'
  //   // );
  //   // await customersModule.registerCustomerAction({
  //   //   firstName: 'Scott',
  //   //   lastName: 'Customer 4',
  //   //   preferredContactMethodId: PreferredContactMethodType.Website,
  //   //   address1: null,
  //   //   city: null,
  //   //   state: null,
  //   //   zipCode: null,
  //   //   email: 'scott+customer4@redhawk-tech.com',
  //   //   website: 'https://facebook.com'
  //   // });
  //   // await authenticationModule.logoutAction();
  //   // await authenticationModule.acceptTermsAction(true);
  //   // await customersModule.registerCustomerIfNeededAction({
  //   //   firstName: 'Scott',
  //   //   lastName: 'Customer 7',
  //   //   preferredContactMethodId: PreferredContactMethodType.Website,
  //   //   address1: null,
  //   //   city: null,
  //   //   state: null,
  //   //   zipCode: null,
  //   //   email: 'scott+customer7@redhawk-tech.com',
  //   //   website: 'https://facebook.com'
  //   // });
  //   // await customersModule.updateCustomerAction({
  //   //   id: 'CD7696D5-8B80-4021-969C-A6E77A8A4E94',
  //   //   firstName: 'Scott',
  //   //   lastName: 'Customer 2',
  //   //   preferredContactMethodId: PreferredContactMethodType.Call,
  //   //   email: 'scott+customer2@redhawk-tech.com',
  //   //   phoneNumber: '5555555555',
  //   //   phoneNumberTypeId: PhoneNumberType.Mobile
  //   // });

  //   // const registeredTagModule = getModule(RegisteredTagModule, store);
  //   // await authenticationModule.acceptTermsAction(true);
  //   // await registeredTagModule.isTagRegisteredAction('z12345');
  //   // await registeredTagModule.getTagByIdAction(
  //   //   'C8F9750F-952E-47E9-B8C9-0067BA37ABEE'
  //   // );
  //   // await registeredTagModule.getTagByCodeAction('Z02425');
  //   // await registeredTagModule.isTagRegistered('Z00000');
  //   // await registeredTagModule.getAllTagsAction();
  //   // await registeredTagModule.getAllTagsByVeterinarianOfficeIdAction(
  //   //   '6216D82B-D437-463F-A5ED-5C5A91EC7B40'
  //   // );
  //   // await registeredTagModule.addNewTagAction({
  //   //   code: 'Z00000',
  //   //   veterinarianOfficeId: 'AFB50A9E-0D78-4247-820F-0045093545D0',
  //   //   customerId: 'E61654F6-E2B7-4B90-8AE7-00775CCA16C7'
  //   // });
  //   // await registeredTagModule.updateTagAction({
  //   //   id: '93B0B2B3-EC4E-498F-8A47-010C6FA6A163',
  //   //   customerId: '686b5816-a8d7-49e3-9ba1-b3ec4348c920',
  //   //   veterinarianOfficeId: 'BEAC5294-7E97-4ED8-A132-483ABDE1E613',
  //   //   code: 'Z02999'
  //   // });

  //   // await authenticationModule.logoutAction();
  //   // await authenticationModule.acceptTermsAction(true);
  //   // const paymentsService: PaymentsService = container.get<PaymentsService>(
  //   //   cid.PaymentsService
  //   // );

  //   // const obj = await paymentsService.createPaymentRequestObject({
  //   //   orderNumber: '123xyz'
  //   // });

  //   // console.log(obj);

  //   // const resp = await paymentsService.verifyPaymentResponse({
  //   //   response:
  //   //     '{"requestId":"Z88888","gatewayResponse":{"status":"Approved","reference":"DSQBOJTEQL","message":"APPROVED 000003","code":"000003","cvvResult":"P","avsResult":" ","riskCode":"00","networkId":"10","isPurchaseCard":false,"orderNumber":"Z88888","transactionId":"MzViZGNiMjhiMDM5MGVkY2M4ZDc4NDZkNTdjYjM3NmY","timestamp":"2020-09-30T13:42:54.0087868-04:00","maskedNumber":null,"expiration":null,"cardHolderName":null,"brand":null,"issuerCountry":null,"transactionCurrency":null,"language":null,"hasChip":false,"fallBackReason":null,"frontEndPrompt":null,"isOfflineDecline":false}}',
  //   //   hash:
  //   //     'EMN2+eePg4fT3Nd7SwMAgUQ9nYrVWiJa/JaqhrGO0yvCoJsXm8EhAJfJwfS9GLYE/7RB4bJltOKhP2Cu54AbOA=='
  //   // });

  //   // console.log(resp);
  // }

  public onForgotPasswordClick() {
    authenticationModule.changeComponentStateAction(false);
  }
}
